// import React, { useState, useEffect } from 'react';
// import { Card, CardTitle, CardBody, Button, Input, Table } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import { useSelector } from 'react-redux';
// import VendorBranchSelector from '../../components/VendorBranchSelector';

// const CourseExamPatternList = () => {
//   const { user } = useSelector((state) => state.authState);
//   const navigate = useNavigate();

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [patternList, setPatternList] = useState([]);
//   const [errorMessage, setErrorMessage] = useState({});

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });
//   const [search, setSearch] = useState('');
//   const onHandleAdd = () => navigate('/save-course-exam-pattern');

//   const onHandleEdit = (id) => {
//     const selected = patternList.find((x) => x.id === id);
//     navigate('/save-course-exam-pattern', { state: { ...(selected || {}) } });
//   };

//   const getPatternList = async (searchText = '') => {
//     try {
//       const res = await apiService.get(
//         `api/ExamMaster/GetAllCourseExamPattern?vendorId=${
//           selectionData.vendor_id || ''
//         }&branchId=${selectionData.branch_id || ''}&search=${searchText}`
//       );

//       if (res?.status) {
//         setPatternList(res.data || []);
//       }
//     } catch {
//       alert('Something went wrong');
//     }
//   };
//   const onHandleSearch = (e) => {
//     const val = e.target.value;
//     setSearch(val);
//     getPatternList(val);
//   };
//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       getPatternList();
//     }
//     // eslint-disable-next-line
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   return (
//     <>
//       <div className='text-right mb-2'>
//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Course Exam Pattern
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 mb-0'>
//           <i className='bi bi-journal-text mr-2' /> Course Exam Pattern List
//         </CardTitle>
//         <div className='p-2'>
//           <Input
//             placeholder='Search term...'
//             value={search}
//             onChange={onHandleSearch}
//           />
//         </div>
//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Course</th>
//                 <th>Exam Term</th>
//                 <th>Total Marks</th>
//                 <th>Weightage %</th>
//                 <th>Grade</th>
//                 <th>Passing Grade</th>
//               </tr>
//             </thead>
//             <tbody>
//               {patternList.length > 0 ? (
//                 patternList.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>
//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleEdit(x.id)}
//                       />
//                     </td>
//                     <td>{x.course_name}</td>
//                     <td>{x.term_name}</td>
//                     <td>{x.total_marks}</td>
//                     <td>{x.weightage_percet}</td>
//                     <td>{x.evaluated_by}</td>
//                     <td>{x.passing_grade}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='6' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default CourseExamPatternList;

//SignalR
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, CardTitle, CardBody, Button, Input, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'CourseExamPattern';

const CourseExamPatternList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [patternList, setPatternList] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });
  const [search, setSearch] = useState('');

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => navigate('/save-course-exam-pattern');

  const onHandleEdit = (id) => {
    const selected = patternList.find((x) => x.id === id);
    navigate('/save-course-exam-pattern', { state: { ...(selected || {}) } });
  };

  const getPatternList = useCallback(async (searchText = '') => {
    try {
      const res = await apiService.get(
        `api/ExamMaster/GetAllCourseExamPattern?vendorId=${selectionData.vendor_id || ''}&branchId=${selectionData.branch_id || ''}&search=${encodeURIComponent(searchText)}`
      );

      if (res?.status) {
        setPatternList(res.data || []);
      } else {
        setPatternList([]);
      }
    } catch {
      alert('Something went wrong');
      setPatternList([]);
    }
  }, [selectionData.vendor_id, selectionData.branch_id]);

  const onHandleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    getPatternList(val);
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      getPatternList(search);
    }
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    search,
    getPatternList,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;
        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);
          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor = String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch = String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            getPatternList(search);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) setupSignalR();

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    search,
    getPatternList,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();
      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(console.error);
      }
    };
  }, []);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Course Exam Pattern
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-journal-text mr-2' /> Course Exam Pattern List
        </CardTitle>
        <div className='p-2'>
          <Input
            placeholder='Search term...'
            value={search}
            onChange={onHandleSearch}
          />
        </div>
        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Course</th>
                <th>Exam Term</th>
                <th>Total Marks</th>
                <th>Weightage %</th>
                <th>Grade</th>
                <th>Passing Grade</th>
              </tr>
            </thead>
            <tbody>
              {patternList.length > 0 ? (
                patternList.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                      />
                    </td>
                    <td>{x.course_name}</td>
                    <td>{x.term_name}</td>
                    <td>{x.total_marks}</td>
                    <td>{x.weightage_percet}</td>
                    <td>{x.evaluated_by}</td>
                    <td>{x.passing_grade}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='8' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default CourseExamPatternList;